import { Link } from '@remix-run/react'
import * as React from 'react'
import { Steps } from '#app/components/ui/progress.tsx'
import { Monogram } from '#app/components/monogram.tsx'

/**
 * Split auth layout: photo (hidden on mobile) | form panel with brand row, centred body, footer row.
 * steps: { total, current, labels } renders the onboarding progress bar above the body.
 */
export function AuthShell({
	image,
	imageAlt = '',
	caption,
	topRight,
	footer,
	steps,
	title,
	lead,
	children,
}: {
	image: string
	imageAlt?: string
	caption?: React.ReactNode
	topRight?: React.ReactNode
	footer?: React.ReactNode
	steps?: { total: number; current: number; labels?: string[] }
	title?: React.ReactNode
	lead?: React.ReactNode
	children: React.ReactNode
}) {
	return (
		<div className="grid min-h-screen grid-cols-1 md:grid-cols-2">
			<div className="relative hidden overflow-hidden md:block">
				<img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" />
				<div className="absolute inset-0 bg-gradient-to-b from-transparent from-50% to-[#0F0E0C]/55" />
				{caption ? <div className="absolute inset-x-10 bottom-9 z-[1] text-white">{caption}</div> : null}
			</div>
			<div className="flex flex-col px-5 py-6 md:px-10 md:py-8">
				<div className="flex items-center justify-between">
					<Link to="/" className="text-[26px]">
						<Monogram />
					</Link>
					{topRight}
				</div>
				<div className="mx-auto flex w-full max-w-[420px] flex-1 flex-col justify-center py-12">
					{steps ? <Steps {...steps} className="mb-10" /> : null}
					{title ? <h1 className="mb-3 font-serif text-[60px] leading-[.95] tracking-[-.01em] [&_em]:italic [&_em]:text-brown">{title}</h1> : null}
					{lead ? <p className="mb-8 text-base text-stone">{lead}</p> : null}
					{children}
				</div>
				{footer ? <div className="flex flex-wrap items-center justify-between gap-4 text-sm text-stone">{footer}</div> : null}
			</div>
		</div>
	)
}
